import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

function NavBar({ isDemoPage, location, menuOpen, setMenuOpen, whoOpen, setWhoOpen, isSticky = false }) {
    const { t } = useTranslation();

    const whoWeAreActive =
        location.pathname === "/our-story" || location.pathname === "/about-byg";

    return (
        <>
            <nav className="relative z-50 flex-row justify-between align-middle items-center p-4 flex px-2 sm:px-12 bg-transparent">
                <div className="flex items-center">
                    <NavLink to="/">
                        <img
                            className="w-[137px] transition-all duration-1000 ease-in-out transform cursor-pointer mr-8"
                            src={
                                isDemoPage && !isSticky
                                    ? require("../media/images/logo-white.png")
                                    : require("../media/images/logo.png")
                            }
                            alt="Eloquenti Logo"
                        />
                    </NavLink>

                    {/* Who We Are Dropdown */}
                    <div className="hidden md:flex items-center relative group mr-6">
                        <span
                            className={`flex justify-center items-center text-sm lg:text-base font-medium mt-1 cursor-pointer ${isDemoPage && !isSticky
                                    ? "text-white hover:text-white"
                                    : whoWeAreActive
                                        ? "text-[#6712FF] font-semibold"
                                        : "text-gray-700 hover:text-[#9B29FF]"
                                }`}
                        >
                            {t('nav.whoWeAre')}
                            <span className="ml-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="6"
                                    viewBox="0 0 11 6"
                                    fill="none"
                                >
                                    <path
                                        d="M0.46875 0.585449L5.46875 4.58545L10.4688 0.585449"
                                        stroke={isDemoPage && !isSticky ? "#FFFFFF" : "#6712FF"}
                                        strokeWidth="1.5"
                                    />
                                </svg>
                            </span>
                        </span>

                        <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                            <NavLink
                                to="/our-story"
                                className={({ isActive }) =>
                                    `block px-4 py-3 text-sm transition-colors ${isActive
                                        ? "text-[#6712FF] bg-purple-50 font-semibold"
                                        : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                {t('nav.ourStory')}
                            </NavLink>
                            <NavLink
                                to="/about-byg"
                                className={({ isActive }) =>
                                    `block px-4 py-3 text-sm transition-colors ${isActive
                                        ? "text-[#6712FF] bg-purple-50 font-semibold"
                                        : "text-gray-700 hover:bg-gray-100"
                                    }`
                                }
                            >
                                {t('nav.aboutByg')}
                            </NavLink>
                        </div>
                    </div>

                    {/* Blog Link */}
                    <NavLink
                        to="/blogs"
                        className={({ isActive }) =>
                            `hidden md:block text-sm lg:text-base transition-colors font-medium mt-1 ${isDemoPage && !isSticky
                                ? "text-white hover:text-white"
                                : isActive
                                    ? "text-[#6712FF] font-semibold"
                                    : "text-gray-700 hover:text-[#9B29FF]"
                            }`
                        }
                    >
                        {t('nav.blog')}
                    </NavLink>
                </div>

                <div className="flex items-center gap-4 ml-4">
                    {/* Language Selector */}
                    <LanguageSelector isDemoPage={isDemoPage} isSticky={isSticky} />

                    {/* Demo Button */}
                    <NavLink
                        to="/demo"
                        className={`hidden md:block text-sm lg:text-base py-2 px-6 lg:px-8 border border-[#9B29FF] bg-[#9B29FF] text-[--primary-light] rounded-full z-10
          hover:bg-white hover:bg-background-gradient-hover transition-all duration-300 ease-in-out hover:text-[#9B29FF] ${isDemoPage ? "invisible pointer-events-none" : "visible"
                            }`}
                    >
                        {t('nav.bookDemo')}
                    </NavLink>

                    {/* Mobile Menu Button */}
                    <button
                        className={`md:hidden float-right ml-auto ${isDemoPage ? "text-white" : "text-black"
                            }`}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>
            </nav>
        </>
    );
};

export default NavBar;
